import React from 'react';
import './style.css';

type FontAwesomeIconProps = {
  icon: string;
  className?: string;
} & React.ComponentProps<'i'>;

export const FontAwesomeIcon: React.FC<FontAwesomeIconProps> = ({
  icon,
  className = '',
  ...rest
}) => {
  return <i className={`font-awesome-icon ${icon} ${className}`} {...rest} />;
};
